import uniqBy from 'lodash/uniqBy';

import { type CustomFieldPayload } from '../containers/customField';

export const removeDuplicates = (
  customField: NonNullable<CustomFieldPayload['values']>,
): NonNullable<CustomFieldPayload['values']> => {
  return uniqBy(customField, (field) => field.value.toLowerCase());
};
